import React from 'react';
import PropTypes from 'prop-types';
import { shippingAddressProps } from './props';

const propTypes = {
  className: PropTypes.string.isRequired,
  shippingAddress: shippingAddressProps.isRequired,
};

export default function ShippingAddress({ className, shippingAddress }) {
  const {
    accessPointName,
    address1,
    address2,
    country,
    formattedCityStateZip,
    formattedName,
  } = shippingAddress;

  return (
    <div className={`order-details-${className}`}>
      {accessPointName && <p>{accessPointName}</p>}
      <p>{formattedName}</p>
      <p>{address1}</p>
      {address2 && <p>{address2}</p>}
      <p>{formattedCityStateZip}</p>
      <p>{country}</p>
    </div>
  );
}

ShippingAddress.propTypes = propTypes;
